import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import axios from "axios";
import Swal from 'sweetalert2';
import CustomTable from '../../helpers/custom-table-admin'
import { catchError } from '../../helpers/catch-error'
import { NavLink } from "react-router-dom";
import { FaPlus, FaCopy, FaClone } from "react-icons/fa";


const ActiveWorkOrders = () => {
  const navigate = useNavigate();
  const [counts, setCounts] = React.useState({ total_active: 0, pending_today: 0 });
  const [searchText, setSearchText] = React.useState("");
  const [appliedSearch, setAppliedSearch] = React.useState("");
  var columns = React.useMemo(
    () => [
      {
        accessorFn: row => row.work_order_id + "_" + row.work_order_no + "_" + row.is_updated,
        id: "work_order_id",
        cell: ({ getValue }) => (
          <a className={(getValue().split("_"))[2] == 1 ? "fw-bold text-shadow text-danger" : ""}
            href={"/admin/work-order/" + (getValue().split("_"))[0]}
            onClick={() => updateWorkOrder((getValue().split("_"))[0])}
          >{(getValue().split("_"))[1]}</a>
        ),
        header: () => "ID",
        size: 100,
      },
      {
        accessorFn: row => row.wo_creation_date_days > 14 ? row.wo_creation_date + "_" + "2 Weeks+" : row.wo_creation_date + "_" + row.wo_creation_date_days + " days",
        id: "wo_creation_date",
        cell: ({ getValue }) => (
          <span>
            <ul className="table-ul">
              {(getValue().split("_")).map((p, index) => (
                <li key={index}>{p}</li>
              ))}
            </ul>
          </span>
        ),
        header: () => "Date",
        footer: props => props.column.id,
        size: 150,
      },
      {
        accessorFn: row => row.patient_last_name + " " + row.patient_first_name,
        id: "lastName",
        cell: info => info.getValue(),
        header: () => "Patient",
        footer: props => props.column.id
      },
      {
        accessorFn: row => row.facility_name + "_" + row.facility_contact_name,
        id: "facility_name",
        cell: ({ getValue }) => (
          <span>
            <ul className="table-ul">
              {(getValue().split("_")).map((p, index) => (
                <li key={index}>{p}</li>
              ))}
            </ul>
          </span>
        ),
        header: () => "FACILITY",
        footer: props => props.column.id,
        size: 150,
      },
      {
        accessorKey: "wo_request_submitted_by",
        header: "Created By",
        footer: props => props.column.id
      },
      {
        accessorKey: "client_company_name",
        header: "Client",
        footer: props => props.column.id
      },
      {
        accessorFn: row => <>
          <a onClick={() => replicateWorkOrder(row.work_order_id)} href="javascript:void(0)" className="btn btn-success btn-sm me-2" title="Replicate" ><FaClone title="Replicate" /></a>
          <a onClick={() => copyWorkOrder(row.work_order_id)} href="javascript:void(0)" className="btn btn-success btn-sm me-2"><FaCopy title="Copy" /></a>
          <a onClick={() => openNewWorkOrder(row.work_order_id)} href="javascript:void(0)" className="btn btn-success btn-sm me-2"><FaPlus title="New" /></a>
        </>,
        id: "actions",
        cell: info => info.getValue(),
        header: () => "ACTIONS",
        footer: props => props.column.id,
        enableColumnFilter: false,
        enableSorting: false,
        size: 120,


      },
      {
        accessorFn: row => [row.follow_up_days, row.authorization_status, row.unapproved_medical_record, row.status, row.wo_partial_patient_authorization, row.follow_up_date, row.blank_authorization_datetime, row.wo_patient_special_authorization_datetime, row.max_notes_created_at, row.pending_payments, row.paid_payments, row.problem_case, row.facility_contact_name],
        id: "notes",
        enableColumnFilter: true,

        // Custom filter function: generate the messages as a single string
        filterFn: (row, columnId, filterValue) => {
          const arr = row.getValue(columnId);
          const messages = [];

          if (arr[0] == 0) messages.push("FOLLOW-UP DATE NEEDED");
          if (arr[0] > 0) messages.push("FOLLOW-UP DATE EXPIRED");
          if (arr[1] == 1 && arr[2] && (arr[3] == 1 || arr[3] == 3)) messages.push("FACILITY HAS UPLOADED RECORD");
          if (arr[1] == 0 && arr[3] >= 1) messages.push("PATIENT AUTHORIZATION NEEDED");
          if (arr[3] == 0.5) messages.push("PENDING APPROVAL");
          if (arr[3] == 2) messages.push("CLIENT/CASE MANAGER ACTION REQUIRED");
          if (arr[3] >= 1 && !arr[4]) messages.push("WO PATIENT AUTHORIZATION NEEDED");
          if (!arr[5]) messages.push("NEED STATUS");
          if (arr[6] && !arr[7]) messages.push("ON HOLD");
          if (arr[7] && (!arr[8] || new Date(arr[8]) < new Date(arr[7]))) messages.push("SPECIAL AUTHORIZATION UPLOAD BY CLIENT/CM");
          const contactSuffix = arr[12] ? ` (${arr[12]})` : "";

          if (arr[9] && arr[10]) messages.push("PENDING PAYMENT (PAID)"); else if (arr[9]) messages.push("PENDING PAYMENT"+contactSuffix); else if (arr[10]) messages.push("PAID PAYMENT");;

          if (arr[11] > 0) messages.push("PROBLEM CASE");
          // join messages as string and check if it includes the filter value
          return messages.join(" ").toLowerCase().includes(filterValue.toLowerCase());
        },

        cell: ({ getValue }) => {
          const arr = getValue();
          return (
            <>
              {arr[0] == 0 && <div className="fw-bold text-dark ">FOLLOW-UP DATE NEEDED</div>}
              {arr[0] > 0 && <div className="fw-bold text-dark ">FOLLOW-UP DATE EXPIRED</div>}
              {arr[1] == 1 && arr[2] && (arr[3] == 1 || arr[3] == 3) && <div className="fw-bold text-danger ">FACILITY HAS UPLOADED RECORD</div>}
              {arr[1] == 0 && arr[3] >= 1 && <div className="fw-bold text-warning  ">PATIENT AUTHORIZATION NEEDED</div>}
              {arr[3] == 0.5 && <div className="fw-bold text-dark">PENDING APPROVAL</div>}
              {arr[3] == 2 && <div className="fw-bold text-dark">CLIENT/CASE MANAGER ACTION REQUIRED</div>}
              {arr[3] >= 1 && !arr[4] && <div className="fw-bold text-primary">WO PATIENT AUTHORIZATION NEEDED{arr[4]}</div>}
              {!arr[5] && <div className="fw-bold text-primary">NEED STATUS</div>}
              {arr[6] && !arr[7] && <div className="fw-bold text-primary">ON HOLD</div>}
              {arr[7] && (!arr[8] || new Date(arr[8]) < new Date(arr[7])) && <div className="fw-bold text-success">SPECIAL AUTHORIZATION UPLOAD BY CLIENT/CM</div>}
              {arr[9] && arr[10] ? (
                <div className="fw-bold text-danger">PENDING PAYMENT (PAID)</div>
              ) : arr[9] ? (
                <div className="fw-bold text-danger">PENDING PAYMENT {arr[12] ? ` (${arr[12]})` : ""}</div>
              ) : arr[10] ? (
                <div className="fw-bold text-success">PAID PAYMENT</div>
              ) : null}
               {arr[11] > 0 && (
                <div className="fw-bold text-danger">PROBLEM CASE</div>
              )}
            </>
          )
        },

        header: () => "NOTES",
        size: 300,
      },
      /* {
         accessorFn: row => [row.follow_up_days, row.authorization_status, row.unapproved_medical_record, row.status, row.wo_partial_patient_authorization, row.follow_up_date, row.blank_authorization_datetime, row.wo_patient_special_authorization_datetime, row.max_notes_created_at,row.pending_payments],
         id: "notes",
         enableColumnFilter: true,
         cell: ({ getValue }) => (
           <>
 
             {(getValue())[0] == 0 &&
               <div className="fw-bold text-dark ">FOLLOW-UP DATE NEEDED</div>
 
             }
             {(getValue())[0] > 0 &&
               <div className="fw-bold text-dark ">FOLLOW-UP DATE EXPIRED</div>
 
             }
             {getValue()[1] == 1 && getValue()[2] && (getValue()[3] == 1 || getValue()[3] == 3) &&
 
               <div className="fw-bold text-danger ">FACILITY HAS UPLOADED RECORD</div>
 
             }
 
 
 
             {getValue()[1] == 0 && getValue()[3] >= 1 &&
 
               <div className="fw-bold text-warning  ">PATIENT AUTHORIZATION NEEDED</div>
 
             }
 
             {getValue()[3] == 0.5 &&
               <div className="fw-bold text-dark">PENDING APPROVAL</div>
 
             }
             {getValue()[3] == 2 &&
 
               <div className="fw-bold text-dark">ClIENT/CASE MANAGER ACTION REQUIRED</div>
 
             }
 
             {getValue()[3] >= 1 && !getValue()[4] &&
 
               <div className="fw-bold text-primary">WO PATIENT AUTHORIZATION NEEDED{getValue()[4]}</div>
 
             }
             {!getValue()[5] &&
 
               <div className="fw-bold text-primary">NEED STATUS</div>
 
             }
 
             {getValue()[6] && !getValue()[7] &&
 
               <div className="fw-bold text-primary">ON HOLD</div>
 
             }
 
             {getValue()[7] && (!getValue()[8] || new Date(getValue()[8]) < new Date(getValue()[7])  ) &&
 
                <div className="fw-bold text-success">SPECIAL AUTHORIZATION UPLOAD BY CLIENT/CM</div>
 
             }
              {getValue()[9] && 
 
               <div className="fw-bold text-danger">PENDING PAYMENT</div>
 
             }
 
 
 
           </>
 
         ),
         header: () => "NOTES",
         size: 300,
       },
 */




    ],
    []
  )


  const [data, setData] = React.useState(null);

const getWorkOrders = async () => {

  await axios.get(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/get-active-work-orders", {
    withCredentials: true
  })
    .then(function (response) {

      if (response?.data?.status) {

        const workOrders = response?.data?.work_orders || [];

        setData(workOrders);

        // Derive all counts client-side from the work_orders array
        let total_active = 0;
        let pending_today = 0;
        let pending_payment_today = 0;
        let pending_payment_total = 0;

        workOrders.forEach((wo) => {
          total_active++;

          // "today" means follow_up_days === 0 (matches backend's
          // TIMESTAMPDIFF(DAY, DATE(follow_up_date), CURDATE()))
          const isToday = wo.follow_up_days >= 0;

          if (isToday) pending_today++;

          const isPendingPayment = wo.pending_payments && !wo.paid_payments;

          if (isPendingPayment) {
            pending_payment_total++;
            if (isToday) pending_payment_today++;
          }
        });

        setCounts({
          total_active,
          pending_today,
          pending_payment_today,
          pending_payment_total
        });

      } else {

        Swal.fire({ icon: "error", title: "Active Work Orders Failed to Load" });

      }

    })
    .catch(function (error) {

      catchError(error, navigate)

    });

}

  const updateWorkOrder = async (work_order_id) => {

    await axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/update-is-updated-work-order", {
      work_order_id: work_order_id
    }, {
      withCredentials: true
    })
      .then(function (response) {

        if (response?.data?.status) {

          getWorkOrders();

        } else {

          Swal.fire({ icon: "error", title: "unable to update work order status" });

        }

      })
      .catch(function (error) {

        // catchError(error, navigate)
      });


  }



  const copyWorkOrder = async (work_order_id) => {

    await axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/copy-work-order", {
      work_order_id: work_order_id
    }, {
      withCredentials: true
    })
      .then(function (response) {

        if (response?.data?.status) {

          getWorkOrders();
          Swal.fire({ icon: "success", title: "Work order copied successfully. " });

        } else {

          Swal.fire({ icon: "error", title: "Unable to copy work order " });

        }

      })
      .catch(function (error) {

        //    catchError(error, navigate)

      });


  }

  const replicateWorkOrder = async (work_order_id) => {

    await axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/replicate-work-order", {
      work_order_id: work_order_id
    }, {
      withCredentials: true
    })
      .then(function (response) {

        if (response?.data?.status) {

          getWorkOrders();
          Swal.fire({ icon: "success", title: "Work order replicated successfully. " });


        } else {

          Swal.fire({ icon: "error", title: "Unable to replicate work order" });

        }

      })
      .catch(function (error) {

        // catchError(error, navigate)

      });


  }

  const openNewWorkOrder = async (work_order_id) => {

    await axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/open-new-work-order", {
      work_order_id: work_order_id
    }, {
      withCredentials: true
    })
      .then(function (response) {

        if (response?.data?.status) {

          getWorkOrders();
          Swal.fire({ icon: "success", title: "A new case has been opened." });


        } else {

          Swal.fire({ icon: "error", title: "Unable to open new work order" });

        }

      })
      .catch(function (error) {

        //  catchError(error, navigate)
      });


  }


const filteredData = React.useMemo(() => {
  if (!appliedSearch?.trim()) return data;

  const search = appliedSearch.toLowerCase().trim();
  const searchTokens = search.split(" ").filter(Boolean);

  return data.filter((row) => {
    const first = (row.patient_first_name || "").toLowerCase().trim();
    const last = (row.patient_last_name || "").toLowerCase().trim();

    const fullName = `${first} ${last}`.trim();
    const reverseName = `${last} ${first}`.trim();

    // ✅ flexible patient matching (handles "john doe", "doe john", "jo do", etc.)
    const patientMatch = searchTokens.every((t) =>
      first.includes(t) ||
      last.includes(t) ||
      fullName.includes(t) ||
      reverseName.includes(t)
    );

    const facility = (row.facility_name || "").toLowerCase();
    const client = (row.client_company_name || "").toLowerCase();
    const createdBy = (row.wo_request_submitted_by || "").toLowerCase();
    const workOrderNo = (row.work_order_no || "").toLowerCase();
    const workOrderId = String(row.work_order_id || "").toLowerCase();

    const generalMatch =
      facility.includes(search) ||
      client.includes(search) ||
      createdBy.includes(search) ||
      workOrderNo.includes(search) ||
      workOrderId.includes(search);

    return patientMatch || generalMatch;
  });
}, [data, appliedSearch]);


  const handleSearch = () => setAppliedSearch(searchText);

  const handleReset = () => {
    setSearchText("");
    setAppliedSearch("");
  };

  useEffect(() => {

    getWorkOrders();

  }, []);

  return (
    <>

      {data &&
        <>
          <div className="row py-2 start-0 bg-light">

            <div className="col-md-12 col-sm-12 mx-auto text-center">
              <div className="container-fluid z-2  ">

                <span className="btn btn-success rounded-0 me-1">
                  <NavLink className="nav-link" smooth to="/admin/work-orders-active">
                    ACTIVE
                  </NavLink>
                </span>

                 { localStorage.getItem('@is_super_admin') == 1 &&
           <>                            
                <span className="btn btn-warning rounded-0 me-1">
                  <NavLink className="nav-link" smooth to="/admin/work-orders-invoice-needed">
                    INVOICE NEEDED
                  </NavLink>
                </span>
                <span className="btn btn-warning rounded-0  me-1 ">
                  <NavLink className="nav-link" smooth to="/admin/work-orders-records-obtained">
                    RECORDS OBTAINED
                  </NavLink>
                </span>

                <span className="btn btn-warning rounded-0  me-1 ">
                  <NavLink className="nav-link" smooth to="/admin/work-orders-closed">
                    CLOSED
                  </NavLink>
                </span>

                <span className="btn btn-warning rounded-0  me-1 ">
                  <NavLink className="nav-link" smooth to="/admin/work-orders-archived">
                    ARCHIVED
                  </NavLink>
                </span>
                </>
}
                <span className="btn btn-warning rounded-0  me-1 ">
                  <NavLink className="nav-link" smooth to="/admin/work-orders-canceled">
                    CANCELED
                  </NavLink>
                </span>

                <span className="btn btn-warning rounded-0 me-1 ">
                  <NavLink className="nav-link" smooth to="/admin/work-orders-incomplete">
                    INCOMPLETE
                  </NavLink>
                </span>
                <span className="btn btn-warning rounded-0  ">
                              <NavLink className="nav-link" smooth to="/admin/work-orders-missing">
                                MISSING
                              </NavLink>
                            </span>
              </div>
            </div>
          </div>


          <div className="row py-4 start-0  mx-auto ">

            <div className="col-md-6 col-sm-12  ">
              <h3 className="text-dark my-0">ACTIVE WORK ORDERS</h3>
            </div>

            <div className="col-md-6 col-sm-12 d-flex justify-content-end align-items-center">



              {/* BUTTONS */}
              <div className="text-end">
                <span className="btn btn-primary rounded-0 me-1">
                  <NavLink className="nav-link" to="/admin/work-orders-new">
                    NEW
                  </NavLink>
                </span>

                <span className="btn btn-danger rounded-0">
                  <NavLink className="nav-link" to="/admin/work-orders-search">
                    SEARCH
                  </NavLink>
                </span>
              </div>

            </div>
          </div>

          <div className="card border-4 border-dark rounded-1 card-success mb-4" >

            <div className="card-body p-0" >

            
                <div className="row align-items-center p-3">

                  <div className="col-lg-6">
                    <div className="input-group">



                      <input
                        type="text"
                        className="form-control"
                        placeholder="Search Patient, Facility, Client, Created By, Case #, Work Order ID..."
                        value={searchText}
                        onChange={(e) => setSearchText(e.target.value)}
                        onKeyDown={(e) => e.key === "Enter" && handleSearch()}
                      />

                      <button className="btn btn-primary" type="button" onClick={handleSearch}>Search</button>

                      <button className="btn btn-secondary" type="button" onClick={handleReset}>Reset</button>

                      {appliedSearch && (
                        <span className="input-group-text">
                          Results: <strong className="ms-1">{filteredData.length}</strong>
                        </span>
                      )}

                    </div>
                  </div>

                               
                  <div className="col-lg-6">
                    <div className="d-flex flex-column gap-2">

                      <div className="d-flex justify-content-md-end justify-content-start gap-2">
                        <span className="btn btn-outline-dark btn-sm">
                          Active: <strong>{counts.total_active}</strong>
                        </span>

                        <span className="btn btn-outline-success btn-sm">
                          Pending Today: <strong>{counts.pending_today}</strong>
                        </span>
                      </div>

                      <div className="d-flex justify-content-md-end justify-content-start gap-2">
                        <span className="btn btn-outline-dark btn-sm">
                          Pending Payment: <strong>{counts.pending_payment_total}</strong>
                        </span>
                        <span className="btn btn-outline-success btn-sm">
                          Pending Payment Today: <strong>{counts.pending_payment_today}</strong>
                        </span>

                        
                      </div>

                    </div>
                  </div>



                </div>


              
              <CustomTable columns={columns} data={filteredData} />

            </div>
          </div>
        </>

      }
    </>
  );
};

export default ActiveWorkOrders;